<ng-container *ngIf="displayLabel; else empty">
  {{ displayLabel }}
</ng-container>

<ng-template #empty>
  <i>Click to search SKU</i>
</ng-template>
